import { usePage } from "@inertiajs/inertia-react";
import { AccordionItem } from "@/Components";
import React from "react";

const TeamsReportedText = ({ teamsAnswers, question }) => {
  const teams = usePage().props?.teams?.data || [];

  const teamsWithoutData = teams.filter(
    (team) =>
      Object.keys(teamsAnswers).indexOf(team.id.toString()) === -1 &&
      team.questions.find((q) => q.id === question.id),
  );

  const nl2br = (str) => {
    if (!str) return str;
    return str.replace(/\r\n|\r|\n/g, "<br />");
  };

  const data = Object.keys(teamsAnswers)
    .map((team_id) => {
      const team = teams.find((team) => team.id === Number(team_id));
      const answers = teamsAnswers[team_id].readable_answer.answer;

      return {
        team: team.name,
        key: team.id,
        value: nl2br(answers),
      };
    })
    .concat(
      teamsWithoutData.map((team) => {
        return {
          team: team.name,
          key: team.id,
          value: "-",
        };
      }),
    );

  return (
    <>
      {data.map(({ key, team, value }) => {
        return (
          <AccordionItem
            key={key}
            title={team}
            titleStyle="font-bold text-sm"
            className="border"
            chevron={false}
          >
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: value,
                }}
              />
            </>
          </AccordionItem>
        );
      })}
    </>
  );
};

export default TeamsReportedText;
